// src/services/ors.js
/**
 * Reusable function to get real driving route from OpenRouteService
 * Used by BOTH EmployeeBooking.jsx and TrackBooking.jsx
 */
export const fetchRoute = async (start, end) => {
  const apiKey = process.env.REACT_APP_ORS_KEY;
  if (!apiKey) return null;

  const url = `https://api.openrouteservice.org/v2/directions/driving-car?api_key=${apiKey}&start=${start[1]},${start[0]}&end=${end[1]},${end[0]}`;

  try {
    const res = await fetch(url);
    const data = await res.json();
    const feature = data.features?.[0];
    if (feature?.geometry?.coordinates && feature?.properties?.segments?.[0]) {
      const segment = feature.properties.segments[0];
      const geometry = feature.geometry.coordinates.map(([lng, lat]) => [lat, lng]);
      const distance = segment.distance;
      const duration = segment.duration;
      return { geometry, distance, duration };
    }
  } catch (e) {
    console.error("ORS route error:", e);
  }
  return null;
};